const firebaseConfig = {
  apiKey: "AIzaSyAOcq8Y3qspD0enneQZPXEriZh93sAa1e0",
  authDomain: "pixabay-api-image-project.firebaseapp.com",
  projectId: "pixabay-api-image-project",
  storageBucket: "pixabay-api-image-project.firebasestorage.app",
  messagingSenderId: "258936373277",
  appId: "1:258936373277:web:00c95c0128e85afe04c6f4",
  measurementId: "G-FFNS1TD5P8",
};

export default firebaseConfig;
